import styles from "./pricing-features.module.scss";
import { useMobile } from "@/hooks/use-responsive";
import DesktopPricingFeaturesTable from "@/components/pages/pricing-a/components/pricing-features/desktop-pricing-features-table";
import MobilePricingFeaturesTable from "@/components/pages/pricing-a/components/pricing-features/mobile-pricing-features-table";
import {
  generationsFeatureMap,
  generationsFeaturesData,
  trainingFeatureMap,
  trainingFeaturesData,
} from "@/components/pages/pricing-a/components/pricing-features/pricing-features.data";
import CoverTooltip from "@/components/pages/convert/components/cover-tooltip";
import React from "react";

const PricingFeatures = () => {
  const { isMobile } = useMobile();

  return (
    <div className={styles.features_wrapper}>
      <div className={styles.title}>Full feature list</div>
      {isMobile ? (
        <>
          {/*<MobilePricingFeaturesTable*/}
          {/*  title={"Voice Training"}*/}
          {/*  featureMap={trainingFeatureMap}*/}
          {/*  featuresData={trainingFeaturesData}*/}
          {/*/>*/}
          <MobilePricingFeaturesTable
            title={"Audio Generations"}
            featureMap={generationsFeatureMap}
            featuresData={generationsFeaturesData}
          />
          <CoverTooltip id={"featureTitle"} />
        </>
      ) : (
        <>
          {/*<DesktopPricingFeaturesTable*/}
          {/*  title={"Voice Training"}*/}
          {/*  featureMap={trainingFeatureMap}*/}
          {/*  featuresData={trainingFeaturesData}*/}
          {/*/>*/}
          <DesktopPricingFeaturesTable
            title={"Audio Generations"}
            featureMap={generationsFeatureMap}
            featuresData={generationsFeaturesData}
          />
        </>
      )}
    </div>
  );
};

export default PricingFeatures;
